// FOR TESTNET

// export const supportedChainId = 80001;
// export const infuraId = "d014af161a4b4ffbaa358366e232e2c8";
// export const rpcUrl =
//   "https://polygon-mumbai.infura.io/v3/d014af161a4b4ffbaa358366e232e2c8";

// export const token = "0x39F10DdAE042BF35847c2756ac9150dC4491d709";

// export const advisor = "0x623019231CCEc169A20Fde3Dab9ed1F950d85963";

// export const development = "0x82db174636004d8c56DC19AaaFFDaCb69Da5d943";

// export const influencers = "0x9c035Ac993Ed7b8dBA35946175f924814E09E806";

// export const liquidity = "0x145B856F5811e6A2c0141c96A2ff2D0fd7A9013F";

// export const marketing = "0xa552B6d0Bec727889654aFa1f28303BD4b2A7e01";

// export const presale = "0x2F909083A28D2B941a1AAb8aAAf3028ACBFf977D";

// export const privatesale = "0x259a8F689a6AE1f1fe5955FD59ef495C464e72cA";

// export const staking = "0x20A2E9EF8792239fE57C53C5159b6C0Be46fc8c8";

// export const team = "0xcBFc031B953e2Fc19907016178b97039f8F35385";

// export const treasury = "0x9e24b0a177F71534f04043be393497996Ca0020d";

// FOR MAINNET

export const supportedChainId = 137;
export const infuraId = "b748d58cfc714ccab736a26dfbe18865";
export const rpcUrl =
  "https://polygon-mainnet.infura.io/v3/b748d58cfc714ccab736a26dfbe18865";
export const token = "0x37Ec5538f80f28426F68b3576142A41853aec4b4";
export const advisor = "0xf5ec0Cd058a0553A5538936bbbd51344aDf93654";
export const development = "0x1a96F44382f0FCFcf7006A1c8b9e1a584f6F5f6F";
export const influencers = "0x4311A5B2F96eb6D85bbcF5620bfB3d7d92F2e907";
export const liquidity = "0x33685AE6E2633575A46980E98a9e41c875E3a42e";
export const marketing = "0xE6Bc3f45042950E03e0F503832713cf0A377eFE3";
export const presale = "0x3E870321Fe2baF5E5F8426B592de37E2DA1F4307";
export const privatesale = "0xAc433b9F821d674186589849C4aB215313d61a1b";
export const staking = "0x67f05829a21360a955F8c3a0ed96f03a7932B5c0";
export const team = "0x594e88d15Ab21CBdcc4c3267260b9a66e4BBb48C";
export const treasury = "0x0009Da064c124dD3a339B0D9e90F84b85953d504";

// Token: 0x37Ec5538f80f28426F68b3576142A41853aec4b4
// AdvisorVesting 0xf5ec0Cd058a0553A5538936bbbd51344aDf93654
// DevelopmentVesting 0x1a96F44382f0FCFcf7006A1c8b9e1a584f6F5f6F
// InfulencersVesting 0x4311A5B2F96eb6D85bbcF5620bfB3d7d92F2e907
// LiquidityVesting 0x33685AE6E2633575A46980E98a9e41c875E3a42e
// MarketingVesting 0xE6Bc3f45042950E03e0F503832713cf0A377eFE3
// PreSaleVesting 0x3E870321Fe2baF5E5F8426B592de37E2DA1F4307
// PrivateSaleVesting 0xAc433b9F821d674186589849C4aB215313d61a1b
// StakingRewardVesting 0x67f05829a21360a955F8c3a0ed96f03a7932B5c0
// TeamVesting 0x594e88d15Ab21CBdcc4c3267260b9a66e4BBb48C
// TreasuryVesting 0x0009Da064c124dD3a339B0D9e90F84b85953d504
